import * as signalR from "@microsoft/signalr";
import { store } from "@/store";
import { env } from "@/env";
import { IAppointment, IAskAppointment, IExpeditionNotification, NotificationType, IReceptionNotification, IOtherAppointment } from "@/models";
import { ToastHelper } from "../../helpers/ToastHelper";

const hubUrl = `${env.api.origin}${env.api.hubPath}/appointments`;
const appointmentsHub = new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, { accessTokenFactory: () => store.dispatch("user/getAccessToken") })
    .build();

appointmentsHub.on("AppointmentUpdated", (appointment: IAppointment) => {
    store.commit("security/APPOINTMENT_UPDATED", appointment);

    if (store.state.user.permission.security || store.state.user.permission.reception ||
        store.state.user.permission.expedition) {
        ToastHelper.appointments.toastUpdated(appointment);
    }
});

appointmentsHub.on("AskAppointmentReceptionCreated", (askAppointment: IAskAppointment) => {
    const receptionNotification: IReceptionNotification = {
        askAppointment,
        reception: null,
        type: NotificationType.AskAppointment,
        startTime: askAppointment.startTime,
    };
    store.commit("receptions/ADD_NOTIFICATION", receptionNotification);

    if (store.state.user.permission.security || store.state.user.permission.reception ||
        store.state.user.permission.expedition) {
        ToastHelper.appointments.toastCreated(askAppointment);
    }
});

appointmentsHub.on("AppointmentReceptionCreated", (appointment: IAppointment) => {
    store.commit("security/APPOINTMENT_RECEPTION_CREATED", appointment);
});

appointmentsHub.on("AskAppointmentReceptionRemoved", (askAppointmentId: number) => {
    store.commit("receptions/REMOVE_NOTIFICATION", askAppointmentId);
});

appointmentsHub.on("AppointmentExpeditionCreated", (appointment: IAppointment) => {
    store.commit("security/APPOINTMENT_EXPEDITION_CREATED", appointment);
});

appointmentsHub.on("AskAppointmentExpeditionCreated", (askAppointment: IAskAppointment) => {
    const expeditionNotification: IExpeditionNotification = {
        askAppointment,
        expedition: null,
        type: NotificationType.AskAppointment,
        startTime: askAppointment.startTime,
    };

    store.commit("expeditions/ADD_NOTIFICATION", expeditionNotification);

    if (store.state.user.permission.security || store.state.user.permission.reception ||
        store.state.user.permission.expedition) {
        ToastHelper.appointments.toastCreated(askAppointment);
    }
});

appointmentsHub.on("otherAppointmentCreated", (otherAppointment: IOtherAppointment) => {
    store.commit("otherAppointments/ADD_OTHER_APPOINTMENT", otherAppointment);

    if (store.state.user.permission.security || store.state.user.permission.reception ||
        store.state.user.permission.expedition) {
        ToastHelper.appointments.toastOtherCreated();
    }
});

appointmentsHub.on("OtherAppointmentUpdated", (otherAppointment: IOtherAppointment) => {
    store.commit("otherAppointments/EDIT_OTHER_APPOINTMENT", otherAppointment);

    if (store.state.user.permission.security || store.state.user.permission.reception ||
        store.state.user.permission.expedition) {
        ToastHelper.appointments.toastOtherUpdated();
    }
});

appointmentsHub.on("OtherAppointmentDeleted", (id: number) => {
    store.commit("otherAppointments/DELETE", id);

    if (store.state.user.permission.security || store.state.user.permission.reception ||
        store.state.user.permission.expedition) {
        ToastHelper.appointments.toastOtherDeleted();
    }
});

appointmentsHub.on("AppointmentDeleted", (appointment: IAppointment) => {
    store.commit("security/APPOINTMENT_DELETED", appointment);
});

appointmentsHub.on("AppointmentReceptionUpdated", (appointment: IAppointment) => {
    store.commit("security/APPOINTMENT_UPDATED", appointment);
});

export { appointmentsHub };
